module.exports = __webpack_public_path__ + "media/48.79b29abc.mp3";